import { ConnectionVariableModel } from './ConnectionVariableModel';
import { SendDataConfig } from './WidgetModel';
import { ConnectionTagModel } from './ConnectionTagModel';

export type ConnectionModelType = 'Webhook';

export enum ConnectionRequestType {
  GET = 'get',
  POST = 'post',
}

export enum ConnectionResponseType {
  NONE = 'none',
  SAVE_ATTRIBUTES = 'save_attributes',
  MESSENGER_JSON = 'messenger_json',
}

export enum ConnectionKind {
  AUDIENCE = 'variables_updates',
  WIDGET = 'widget',
}

export enum IntegrationTypes {
  MAILCHIMP = 'mailchimp',
}

export type MailchimpDataType = {
  listId?: string;
  name?: string;
  emailVariableId?: number;
};

export type FormattedConnectionModel = ConnectionModel & {
  statusText: string;
  formattedUpdatedAt: string;
  formattedCreatedAt: string;
};

export type ConnectionModel = {
  id: number;
  name: string;
  connectionType: ConnectionModelType;
  description: string;
  createdAt: string;
  updatedAt: string;
  pluginId: number;
  validationMessages: any;
  url: string;
  variables?: ConnectionVariableModel[];
  audienceId: number | null;
  active: boolean;
  sendDataWidgetConfig?: SendDataConfig;
  requestType: ConnectionRequestType;
  responseType: ConnectionResponseType;
  kind: ConnectionKind;
  tags: ConnectionTagModel[];
  tagsField: string | null;
  googleAccountId: number | null;
  googleAccountEmail: string | null;
  googleLookupColumn: string | null;
  googleSheetId: string | null;
  googleSheetTitle: string | null;
  googleSpreadsheetId: string | null;
  googleSpreadsheetTitle: string | null;
  integrationType: string | null;
  connectionKind: 'google_spreadsheet' | 'mailchimp' | 'zapier' | 'json';
  mailchimpAccountId: number | null;
  mailchimpAccountEmail: string | null;
  mailchimpAccessTokenId: number | null;
  data: MailchimpDataType;
  mailchimpListTitle: string | null;
};

export default ConnectionModel;
